export default {
  id: "string",
  name: "string",
  blocks: "hasMany",
  color: "string"
}



// WEBPACK FOOTER //
// ./src/store/models/template.js